module.exports = __webpack_public_path__ + "img/base_data.e870ad72.svg";